import { TAccountDetail } from "@/modules/auth/type";

export const SessionUser = {
  set: (val: { user: TAccountDetail }) =>
    localStorage.setItem("users", JSON.stringify(val)),

  get: (): { user: TAccountDetail } | undefined => {
    try {
      const users = localStorage.getItem("users");
      return users ? JSON.parse(users) : undefined;
    } catch (e) {
      return undefined;
    }
  },

  remove: () => localStorage.removeItem("users"),
};
